import { QueryModelCore } from '@/core/model.core';
import Browser from '@/core/browser';

export default class Prod {
  /**
   * 获取国家、省、市、区数据
   * @param {string} parentName 国家名称(如果是查国家下的省市区)
   */
  async areaList(parentName) {
    const result = await new QueryModelCore(
      '/api-prod/prodManage/areaQuery'
    ).get({ parentName });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 批量查询产品列表
   * @param {string[]} spuNo 内部自动生成的产品编码数组
   */
  async queryProductList(params) {
    const result = await new QueryModelCore('/api-prod/app/productList').get({
      channel: Browser.ysfMiniprogram ? 2 : 1,
      ...params
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取产品详情
   * @param {string} spuNo 内部自动生成的产品编码
   */
  async productDetail(spuNo, uuid) {
    const result = await new QueryModelCore('/api-prod/app/productDetail').get({
      spuNo,
      channel: Browser.ysfMiniprogram ? 2 : 1,
      subUuid: uuid
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取产品库价信息
   * @param {string} skuNo
   * @param {string} day 日历(年-月)
   */
  async stockPrice(skuNo, day) {
    const result = await new QueryModelCore(
      '/api-prod/app/getStockPriceDay'
    ).get({
      skuNo,
      day,
      channel: Browser.ysfMiniprogram ? 2 : 1
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
  * 获取套餐库价
  * @param {string} skuNo
  * @param {string} startMonth 日历(年-月)
  */
  async stockPriceList(skuNo, startMonth, channel = 1) {
    const result = await new QueryModelCore(
      '/api-prod/app/getSkuStockPriceList'
    ).get({
      skuNo,
      startMonth,
      channel: Browser.ysfMiniprogram ? 2 : 1
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
  * 获取套餐库价-携宠游
  * @param {string} skuNo
  * @param {string} day 日历(年-月-日)
  */
  async stockPriceByOneDay(skuNo, day, channel = 1) {
    const result = await new QueryModelCore(
      '/api-prod/app/getStockPriceByOneDay'
    ).get({
      skuNo,
      day,
      channel: Browser.ysfMiniprogram ? 2 : 1
    });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取搜索产品结果列表(分页)
   * @param {Object} params {
   *    @param {number} current
   *    @param {number} size
   *    @param {string} condition 搜索内容
   *    @param {string} orderBy 价格排序 1-正序 2-倒序
   * }
   */
  async searchProdPagingList(params) {
    const result = await new QueryModelCore('/api-prod/app/searchInfo').get(
      params
    );
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 更改商品收藏信息
   * @param {string} spuNo 内部自动生成的产品编码
   */
  async updateCollectProd(spuNo) {
    const result = await new QueryModelCore(
      '/api-prod/prodCollect/collectProduct'
    ).post({ spuNo });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取收藏列表(分页)
   * @param {number} current
   * @param {number} size
   */
  async getCollectPagingList(params) {
    const result = await new QueryModelCore(
      '/api-prod/prodCollect/getCollectProduct'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 增加分销商产品咨询入口访问量
   */
  async getCompanySpuContactHot(params) {
    const result = await new QueryModelCore(
      '/api-prod/app/addCompanySpuContactHot'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 产品购买数量显示
   */
  async getBarrageBySpuNo(params) {
    const result = await new QueryModelCore(
      '/api-prod/app/getBarrageBySpuNo'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取商品sku全部可售卖月份
   */
  async getSkuStockPriceMonthList(params) {
    const result = await new QueryModelCore(
      '/api-prod/app/getSkuStockPriceMonthList'
    ).get(params);
    const { dataMap } = result;
    return dataMap;
  }

  getSkuStockPriceMonthList
}
